import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitJoin'
})
export class SplitJoinPipe implements PipeTransform {

  transform(value: any, join: any): any {
    return value.toString().replace(/\d{4}(?=.)/g, `$&${join}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/split-join.pipe.ts